import React from "react";
import { useIntl } from "react-intl";
import { PeekBox, PeekStack, PeekTypography, styled, useTheme } from "@piiqtechnologies/ui-components";
import { useAuthContext } from "@stores/AuthContext";
import { getIsDemoUser } from "@stores/utils";
import messages from "./messages.i18n";
const BannerContainer = styled(PeekBox)(({ theme }) => ({
    height: "fit-content",
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(1),
    width: "100%",
}));
export const DemoBanner = () => {
    const intl = useIntl();
    const { user } = useAuthContext();
    const isDemoUser = getIsDemoUser(user);
    const theme = useTheme();
    if (!isDemoUser) {
        return null;
    }
    const handleContactSales = () => {
        window.open("https://www.peek.us/contact", "_blank");
    };
    return (React.createElement(BannerContainer, null,
        React.createElement(PeekStack, { direction: "row", justifyContent: "center", alignItems: "center", spacing: 1 },
            React.createElement(PeekTypography, { variant: "h3", sx: { color: theme.palette.primary.dark } }, intl.formatMessage(messages.demoBannerText)),
            React.createElement(PeekTypography, { variant: "h3", role: "img", "aria-label": "chat" }, "\uD83D\uDCAC"),
            React.createElement(PeekTypography, { variant: "h3", color: theme.palette.text.primary, onClick: handleContactSales, sx: { textDecoration: "underline", cursor: "pointer" } }, intl.formatMessage(messages.demoBannerCta)))));
};
export default DemoBanner;
